import React, { useState } from "react";
import { useOkapiKy } from "@folio/stripes/core";
import { Button, Col, ErrorModal, Modal, Row, TextField, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useMutation } from "react-query";
import { sendTestEmail } from "../../api/adminService";
export var SendTestEmail = function () {
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var _a = useState(""), email = _a[0], setEmail = _a[1];
    var _b = useState(false), modalOpen = _b[0], setModalOpen = _b[1];
    var _c = useState(false), errorModalOpen = _c[0], setErrorModalOpen = _c[1];
    var _d = useState(""), message = _d[0], setMessage = _d[1];
    var _e = useState(""), errorMessage = _e[0], setErrorMessage = _e[1];
    var _f = useMutation(function (to) { return sendTestEmail(ky, to); }, {
        onSuccess: function () {
            setMessage(formatMessage({ id: "ui-br-users.admin.test.email.success" }, { email: email }));
            setModalOpen(true);
        },
        onError: function (error) {
            console.error("Error sending test email:", error);
            setErrorMessage(formatMessage({ id: "ui-br-users.admin.test.email.error" }));
            setErrorModalOpen(true);
        },
    }), handleSend = _f.mutate, isLoading = _f.isLoading;
    return (React.createElement(React.Fragment, null,
        React.createElement(FormattedMessage, { id: "ui-br-users.admin.test.email.title", tagName: "h1" }),
        React.createElement(Modal, { label: React.createElement(FormattedMessage, { id: "ui-br-users.admin.test.email.title" }), open: modalOpen, onClose: function () { return setModalOpen(false); }, dismissible: true }, message),
        React.createElement(ErrorModal, { label: React.createElement(FormattedMessage, { id: "ui-br-users.admin.test.email.title" }), open: errorModalOpen, content: errorMessage, onClose: function () { return setErrorModalOpen(false); } }),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12, md: 6 },
                React.createElement(TextField, { type: "text", label: React.createElement(FormattedMessage, { id: "ui-br-users.admin.test.email.label" }), value: email, onChange: function (e) {
                        return setEmail(e.target.value);
                    }, disabled: isLoading }))),
        React.createElement(Row, null,
            React.createElement(Col, null,
                React.createElement(Button, { buttonStyle: "primary", onClick: function () { return handleSend(email.trim()); }, disabled: isLoading || email.trim().length === 0 }, isLoading ? (React.createElement(FormattedMessage, { id: "ui-br-users.admin.test.email.button.loading" })) : (React.createElement(FormattedMessage, { id: "ui-br-users.admin.test.email.button" })))))));
};
